import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "text-surface-500 dark:text-surface-400 block" }
const _hoisted_2 = { class: "flex flex-col gap-2" }
const _hoisted_3 = {
  for: "email",
  class: "font-semibold"
}
const _hoisted_4 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_5 = { class: "flex flex-col gap-2" }
const _hoisted_6 = {
  for: "expired-password",
  class: "font-semibold"
}
const _hoisted_7 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_8 = { class: "flex flex-col gap-2" }
const _hoisted_9 = {
  for: "new-password",
  class: "font-semibold"
}
const _hoisted_10 = { class: "text-surface-500 dark:text-surface-400" }
const _hoisted_11 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_12 = { class: "flex justify-end gap-2" }

import * as userService from '@/services/userService'
import { useLanguageStore } from '@/stores/LanguageStore'
import { Button, Dialog, InputText, Password, useToast } from 'primevue'
import { reactive, ref } from 'vue'
import { z } from 'zod'


export default /*@__PURE__*/_defineComponent({
  __name: 'RecoverPassword',
  setup(__props) {

const toast = useToast()
const languageStore = useLanguageStore()
const visible = ref(false)
const isLoading = ref(false)

const form = reactive({
  email: '',
  expiredPassword: '',
  newPassword: '',
})

const errors = reactive({
  email: '',
  expiredPassword: '',
  newPassword: '',
})

const schema = z.object({
  email: z.string().email(languageStore.t('auth.requiredChangePassword.validation.emailRequired')),
  expiredPassword: z
    .string()
    .min(1, languageStore.t('auth.requiredChangePassword.validation.expiredPasswordRequired')),
  newPassword: z
    .string()
    .min(8, languageStore.t('auth.requiredChangePassword.validation.minLength'))
    .regex(/[A-Z]/, languageStore.t('auth.requiredChangePassword.validation.newPasswordUppercase'))
    .regex(/[a-z]/, languageStore.t('auth.requiredChangePassword.validation.newPasswordLowercase'))
    .regex(/[0-9]/, languageStore.t('auth.requiredChangePassword.validation.newPasswordNumber'))
    .regex(
      /[!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]/,
      languageStore.t('auth.requiredChangePassword.validation.newPasswordSpecial'),
    ),
})

const validateForm = () => {
  try {
    schema.parse(form)
    return true
  } catch (error) {
    if (error instanceof z.ZodError) {
      errors.email = error.errors.find((e) => e.path[0] === 'email')?.message || ''
      errors.expiredPassword =
        error.errors.find((e) => e.path[0] === 'expiredPassword')?.message || ''
      errors.newPassword = error.errors.find((e) => e.path[0] === 'newPassword')?.message || ''
    }
    return false
  }
}

const cleanForm = () => {
  form.email = ''
  form.expiredPassword = ''
  form.newPassword = ''
  errors.email = ''
  errors.expiredPassword = ''
  errors.newPassword = ''
}

const handleSubmit = async () => {
  if (!validateForm()) return

  isLoading.value = true
  userService
    .recoverPassword(form.email, form.expiredPassword, form.newPassword)
    .then(() => {
      visible.value = false

      toast.add({
        summary: 'Senha Atualizada',
        detail: 'Faça login com seu e-mail e nova senha',
        severity: 'success',
        life: 3000,
      })

      cleanForm()
    })
    .catch((error) => {
      console.error('Error recovering password:', error)

      const errorMessage = (() => {
        if (error.response?.data?.detail) {
          return error.response.data?.detail
        }
        return 'Erro ao recuperar senha'
      })()

      toast.add({
        summary: 'Erro',
        detail: errorMessage,
        severity: 'error',
        life: 3000,
      })
    })
    .finally(() => {
      isLoading.value = false
    })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Button), {
      label: _unref(languageStore).t('auth.login.forgotPassword'),
      variant: "link",
      onClick: _cache[0] || (_cache[0] = () => (visible.value = true)),
      style: {"padding":"0"}
    }, null, 8, ["label"]),
    _createVNode(_unref(Dialog), {
      visible: visible.value,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((visible).value = $event)),
      modal: "",
      header: _unref(languageStore).t('auth.login.forgotPassword'),
      class: "w-[600px]"
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", {
          onSubmit: _withModifiers(handleSubmit, ["prevent"]),
          class: "flex flex-col gap-6"
        }, [
          _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(languageStore).t('auth.requiredChangePassword.instructions')), 1),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("label", _hoisted_3, _toDisplayString(_unref(languageStore).t('auth.requiredChangePassword.emailLabel')), 1),
            _createVNode(_unref(InputText), {
              id: "email",
              modelValue: form.email,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.email) = $event)),
              class: _normalizeClass([{ 'p-invalid': errors.email }, "flex-auto"])
            }, null, 8, ["modelValue", "class"]),
            (errors.email)
              ? (_openBlock(), _createElementBlock("small", _hoisted_4, _toDisplayString(errors.email), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("label", _hoisted_6, _toDisplayString(_unref(languageStore).t('auth.requiredChangePassword.expiredPasswordLabel')), 1),
            _createVNode(_unref(Password), {
              toggleMask: "",
              fluid: "",
              modelValue: form.expiredPassword,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.expiredPassword) = $event)),
              invalid: !!errors.expiredPassword
            }, null, 8, ["modelValue", "invalid"]),
            (errors.expiredPassword)
              ? (_openBlock(), _createElementBlock("small", _hoisted_7, _toDisplayString(errors.expiredPassword), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("label", _hoisted_9, _toDisplayString(_unref(languageStore).t('auth.requiredChangePassword.newPasswordLabel')), 1),
            _createElementVNode("small", _hoisted_10, _toDisplayString(_unref(languageStore).t('auth.requiredChangePassword.passwordRequirements')), 1),
            _createVNode(_unref(Password), {
              toggleMask: "",
              fluid: "",
              modelValue: form.newPassword,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.newPassword) = $event)),
              invalid: !!errors.newPassword
            }, null, 8, ["modelValue", "invalid"]),
            (errors.newPassword)
              ? (_openBlock(), _createElementBlock("small", _hoisted_11, _toDisplayString(errors.newPassword), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_unref(Button), {
              type: "button",
              label: "Cancelar",
              severity: "secondary",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (visible.value = false))
            }),
            _createVNode(_unref(Button), {
              type: "submit",
              label: "Salvar",
              loading: isLoading.value
            }, null, 8, ["loading"])
          ])
        ], 32)
      ]),
      _: 1
    }, 8, ["visible", "header"])
  ], 64))
}
}

})